import { PageController } from '@client/components/_core/layout/PageController';
import { StringListSetting } from '@client/components/_core/settings/StringListSetting';
import { claimUploadDocumentTypesSetting } from '@shared/schemas/org-settings';
import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/documents')({
    staticData: {
        metadata: {
            title: 'Documents',
        },
        ui: {
            title: 'Claims configuration',
        },
    },
    component: Documents,
});

function Documents() {
    return (
        <PageController route={Route}>
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                <StringListSetting
                    definition={claimUploadDocumentTypesSetting}
                    icon={FileText}
                    title="Claim document types"
                    noun="document type"
                    description="The types staff choose from when they upload a document to a claim."
                />
            </div>
        </PageController>
    );
}
